/**
 * Hour tag rule form — the minimum unique visits an hour needs before the
 * tag judges it (below it the hour is Unknown).
 * For Media Devoted | Created By Ciro Autiero
 */

import { Input } from '@/components/ui';

import { HOUR_MIN_VOLUME_MAX } from './hour-presets';

const NUMBER_INPUT = { type: 'number', inputMode: 'numeric', min: 0, max: HOUR_MIN_VOLUME_MAX, step: 1 } as const;
const INVALID = 'A whole number from 0 to 1,000,000.';

interface HourMinVolumeFieldProps {
  value: string;
  onChange: (value: string) => void;
  invalid?: boolean;
}

export function HourMinVolumeField({ value, onChange, invalid }: HourMinVolumeFieldProps) {
  return (
    <div>
      <label htmlFor="hour-min-volume" className="block text-sm font-medium">
        Minimum visits
      </label>
      <p className="mb-2 mt-0.5 text-xs text-muted-foreground">
        Unique visits an hour needs before this tag judges it. Below it the hour is Unknown.
      </p>
      <Input
        id="hour-min-volume"
        {...NUMBER_INPUT}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-32"
        aria-invalid={invalid || undefined}
      />
      {invalid && <p className="mt-1 text-xs text-destructive">{INVALID}</p>}
    </div>
  );
}
